import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DialogContentText, Grid } from "@material-ui/core";

type Props = {
  label: string;
  value?: string;
};

export const DialogRow: React.VFC<Props> = (props) => {
  // styles
  const classes = useStyles();

  return (
    <Grid container className={classes.wrapper}>
      <Grid item xs={12} md={6}>
        <DialogContentText className={classes.key}>
          {props.label}:
        </DialogContentText>
      </Grid>
      <Grid item xs={12} md={6}>
        <DialogContentText className={classes.value}>
          {props.value}
        </DialogContentText>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  wrapper: {
    margin: 10,
    marginBottom: 30,
  },
  key: {
    marginRight: 50,
    whiteSpace: "pre-wrap",
  },
  value: {
    color: "#000",
    whiteSpace: "pre-wrap",
  },
});
